import React, { useState, ChangeEvent } from 'react';
import {
  IWidgetType,
  WidgetType,
  WidgetTypes,
  WidgetTypeDisplayNames,
  IBannerV1Widget,
  IBannerV2Widget,
  IWhoWeAreV1Widget,
  IProjectsV1Widget,
  IServicesV1Widget,
  ITestimonialV1Widget,
  IProjectsListingWidget,
  IProjectDetailsWidget,
  IContactWidget,
  ICompanyDetailsWidget,
  IMediaTextV1Widget
} from 'src/PageWidgetSection';
import { IServicePageWidget } from './items/ServicePageItem';
import {IServiceDetailsWidget} from './items/ServiceDetailsItem';
import GenericSelectInput from '../input-components/GenericSelectInput';
import GenericInput from '../input-components/GenericTextInput';
import { Button, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import BannerV1Item from './items/BannerV1Item';
import BannerV2Item from './items/BannerV2Item';
import WhoWeAreV1Item from './items/WhoWeAreV1Item';
import ServicesV1Item from './items/ServicesV1Item';
import ProjectsV1Item from './items/ProjectsV1Item';
import TestimalV1Item from './items/TestimalV1Item';
import ContactItem from './items/ContactItem';
import ProjectsListingItem from './items/ProjectsListingItem';
import ProjectDetailsItem from './items/ProjectDetailsItem';
import ServicePageItem from './items/ServicePageItem';
import ServiceDetailsItem from './items/ServiceDetailsItem';
import CompanyDetailsItem from './items/ICompanyDetailsItem';
import MediaTextV1Item from './items/MediaTextV1Item';


// Props for the RepeaterItem component.
interface RepeaterItemProps {
  item: WidgetTypes;
  index: number;
  error: {};
  onDelete: (index: number) => void;
  onChange: (index: number, newItem: IWidgetType, feild: string) => void;
  onblur: (index: number, feild: string) => void;
}

// Component for each repeater item.
const RepeaterItem: React.FC<RepeaterItemProps> = ({
  item,
  index,
  error,
  onDelete,
  onblur,
  onChange
}) => {
  // Handler for input changes.
  const handleChange = (value: any, name: string) => {
    // If value is an event (has target.value), then extract it;
    // otherwise, assume it's already the updated value.
    if (value && value.target && typeof value.target.value !== "undefined") {
      const newValue = value.target.value;
      onChange(index, { ...item, [name]: newValue }, name);
    } else {
      // Otherwise, value is already the updated object or field value.
      onChange(index, value, name);
    }
  };
  
  
  const handleChangeSelect = (e: any) => {
    // Dynamically update the property based on input's name.
    onChange(index, { order: item.order, type: e }, 'type');
  };

  const renderCustomFields = () => {
    if (!item.type) {
      return <></>;
    }

    switch (item.type) {
      case WidgetType.BannerV1:
        return (
          <BannerV1Item
            item={item as IBannerV1Widget}
            error={error}
            onChange={(v, n) => {
              handleChange(v, n);
            }}
            onblur={(n) => {
              onblur(index, n);
            }}
          />
        );

      case WidgetType.BannerV2:
        return (
          <BannerV2Item
            item={item as IBannerV2Widget}
            error={error}
            onChange={(v, n) => {
              handleChange(v, n);
            }}
            onblur={(n) => {
              onblur(index, n);
            }}
          />
        );
      // case WidgetType.MECKIN_FOOTER:
      //   return <></>;

      case WidgetType.WhoWeAreV1:
        return (
          <WhoWeAreV1Item
            item={item as IWhoWeAreV1Widget}
            error={error}
            onChange={(v, n) => {
              handleChange(v, n);
            }}
            onblur={(n) => {
              onblur(index, n);
            }}
          />
        );


      case WidgetType.ProjectsV1:
        return (
          <ProjectsV1Item
            item={item as IProjectsV1Widget}
            error={error}
            onChange={(v, n) => {
              handleChange(v, n);
            }}
            onblur={(n) => {
              onblur(index, n);
            }}
          />
        );


      case WidgetType.ServicesV1:
        return (
          <ServicesV1Item
            item={item as IServicesV1Widget}
            error={error}
            onChange={(v, n) => {
              handleChange(v, n);
            }}
            onblur={(n) => {
              onblur(index, n);
            }}
          />
        );

      case WidgetType.TestimonalV1:
        return (
          <TestimalV1Item
            item={item as ITestimonialV1Widget}
            error={error}
            onChange={(v, n) => {
              handleChange(v, n);
            }}
            onblur={(n) => {
              onblur(index, n);
            }}
          />
        );

      case WidgetType.BlogV1:
        return <></>

      case WidgetType.ProjectsListing:
        return (
          <ProjectsListingItem
            item={item as IProjectsListingWidget}
            error={error}
            onChange={(v, n) => {
              handleChange(v, n);
            }}
            onblur={(n) => {
              onblur(index, n);
            }}
          />
        );

      case WidgetType.ProjectDetails:
        return (
          <ProjectDetailsItem
            item={item as IProjectDetailsWidget}
            error={error}
            onChange={(v, n) => {
              handleChange(v, n);
            }}
            onblur={(n) => {
              onblur(index, n);
            }}
          />
        );

      case WidgetType.ServicePage:
        return(
          <ServicePageItem
            item={item as IServicePageWidget}
            error={error}
            onChange={(v, n) => {
              handleChange(v, n);
            }}
            onblur={(n) => {
              onblur(index, n);
            }}
          />
        );

      case WidgetType.ServiceDetails:
        return(
          <ServiceDetailsItem
            item={item as IServiceDetailsWidget}
            error={error}
            onChange={(v, n) => {
              handleChange(v, n);
            }}
            onblur={(n) => {
              onblur(index, n);
            }}
          />
        );

          case WidgetType.BlogsListing:
            return <></>

              case WidgetType.CompanyDetails:
                return(
                  <CompanyDetailsItem
                    item={item as ICompanyDetailsWidget}
                    error={error}
                    onChange={(v, n) => {
                      handleChange(v, n);
                    }}
                    onblur={(n) => {
                      onblur(index, n);
                    }}
                  />
                );

                case WidgetType.Contact:
                  return (
                    <ContactItem
                      item={item as IContactWidget}
                      error={error}
                      onChange={(v, n) => {
                        handleChange(v, n);
                      }}
                      onblur={(n) => {
                        onblur(index, n);
                      }}
                    />
                  );

                case WidgetType.MediaTextV1:
                  return (
                    <MediaTextV1Item
                      item={item as IMediaTextV1Widget}
                      error={error}
                      onChange={(v, n) => {
                        handleChange(v, n);
                      }}
                      onblur={(n) => {
                        onblur(index, n);
                      }}
                    />
                  );

      default:
        return <></>;
    }
  };

  const widgetTypeOptions = Object.values(WidgetType).reduce(
    (acc, typeValue) => {
      acc[typeValue] = WidgetTypeDisplayNames[typeValue];
      return acc;
    },
    {} as Record<string, string>
  );

  return (
    <div style={styles.itemContainer}>
      <IconButton
        color="error"
        style={styles.deleteButton}
        onClick={() => onDelete(index)}
      >
        <DeleteIcon />
      </IconButton>
      <div style={{ marginTop: 20 }}>
        <GenericInput
          type={'number'}
          name="order"
          title="order"
          value={item.order}
          error={error ? error['order'] : ''}
          onChange={(e) => {
            handleChange(e, 'order');
          }}
          onBlur={() => onblur(index, 'order')}
          disabled={false}
        />

        <GenericSelectInput
          name="type"
          title="Type"
          value={item.type + ''}
          error={error ? error['type'] : ''}
          onChange={handleChangeSelect}
          onBlur={() => onblur(index, 'type')}
          disabled={false}
          items={widgetTypeOptions}
          type={''}
        />

        {renderCustomFields()}
      </div>
    </div>
  );
};

interface RepeaterProps {
  items: WidgetTypes[];
  errors: any[];
  deleteItem: (index: number) => void;
  addItem: () => void;
  updateItem: (index: number, newItem: any, feild: string) => void;
  blurItem: (index: number, feild: string) => void;
}

// Main repeater component.
const Repeater: React.FC<RepeaterProps> = ({
  items = [{ order: '', type: '' }],
  errors = [],
  addItem,
  deleteItem,
  updateItem,
  blurItem
}) => {
  return (
    <div style={styles.container}>
      {items.map((item, index) => (
        <RepeaterItem
          key={index}
          item={item}
          error={errors[index]}
          index={index}
          onDelete={deleteItem}
          onChange={updateItem}
          onblur={blurItem}
        />
      ))}
      <Button variant="contained" color="primary" onClick={() => addItem()}>
        Add New Section
      </Button>
    </div>
  );
};

// Inline styles.
const styles: { [key: string]: React.CSSProperties } = {
  container: {
    width: '98%',
    margin: '20px auto',
    fontFamily: 'Arial, sans-serif'
  },
  itemContainer: {
    border: '1px solid #ccc',
    padding: '15px',
    marginBottom: '15px',
    borderRadius: '4px',
    position: 'relative'
  },
  deleteButton: {
    position: 'absolute',
    top: '5px',
    right: '5px',
    padding: '5px 7px',
    cursor: 'pointer'
  },
  inputGroup: {
    marginBottom: '10px'
  },
  label: {
    display: 'block',
    marginBottom: '5px',
    fontWeight: 'bold'
  },
  input: {
    width: '100%',
    padding: '7px',
    fontSize: '14px',
    boxSizing: 'border-box'
  },
  addButton: {
    width: '100%',
    padding: '10px',
    fontSize: '16px',
    backgroundColor: '#29d',
    color: '#fff',
    border: 'none',
    cursor: 'pointer',
    borderRadius: '4px'
  }
};

export default Repeater;
